import { render } from "./PriceCalculation.vue?vue&type=template&id=2d3930f8"
import script from "./PriceCalculation.vue?vue&type=script&lang=js"
export * from "./PriceCalculation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__